import styled from 'styled-components'
import { media, mediaMax } from 'styles/media'
import typeStyle from 'styles/typeStyle'

import SvgIconMessage2 from 'components/icons/Message2'
import SvgIconMail from 'components/icons/Mail'
import SvgIconBookOpen from 'components/icons/BookOpen'
import { ParagraphXs } from 'components/display/Typography'
import { DesktopOnly, MobileOnly } from 'components/display/Breakpoints'
import Button from 'components/display/Button'
import { SectionHeader, SectionRow, BaseCard } from '../styles'

interface CardProps {
  onClick?: Function
}

const BorderCard = styled(BaseCard)<CardProps>`
  border-color: ${({ theme }) => theme?.['-ds-neutral-400']?.value};
  cursor: ${({ onClick }) => (onClick ? 'pointer' : 'default')};
  transition: box-shadow 0.2s ease-in-out;
  ${media.md<CardProps>`
    width: 33.3%;
    flex-direction: column;
    justify-content: flex-start;
    border-width: ${({ onClick }) => (onClick ? '2px' : '1px')};
    border-color: ${({ theme, onClick }) => {
      if (onClick) return theme?.['-ds-core-400']?.value
      return theme?.['-ds-neutral-400']?.value
    }};
    padding: 24px;
  `}
  &:hover {
    ${media.md<CardProps>`
      box-shadow: ${({ onClick }) =>
        onClick
          ? '0px 1px 6px rgba(0, 0, 0, 0.039), 0px 5.5px 16px rgba(0, 0, 0, 0.19);'
          : 'none'};
    `}
  }
  h4 {
    margin-bottom: 8px;
  }
  h4,
  svg {
    ${media.md<CardProps>`
        color: ${({ theme, onClick }) =>
          onClick
            ? theme?.['-ds-core-400']?.value
            : theme?.['-ds-neutral-700']?.value};
      `};
  }
  p {
    margin-bottom: 8px;
  }
  a {
    ${typeStyle('-ds-font-lead-xs-light')}
    text-decoration: none;
    color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    &:hover {
      text-decoration: underline;
      color: ${({ theme }) => theme?.['-ds-core-400']?.value};
    }
  }
`
const BorderCardIcon = styled.div`
  margin-bottom: 10px;
  ${mediaMax.md`
    order: 2;
    margin-left: 35px;
  `}
  svg {
    width: 20px;
    height: 20px;
  }
`
interface ConnectSectionProps {
  openChat: Function
}

const ConnectSection = ({ openChat }: ConnectSectionProps) => {
  return (
    <>
      <DesktopOnly breakpoint="md">
        <SectionHeader>Ways to connect</SectionHeader>
      </DesktopOnly>
      <SectionRow>
        <BorderCard onClick={() => openChat()}>
          <BorderCardIcon>
            <SvgIconMessage2 />
          </BorderCardIcon>
          <div>
            <h4>Chat with us</h4>
            <ParagraphXs>
              The fastest and easiest way to get in touch with us about anything
              and everything.
            </ParagraphXs>
            <MobileOnly style={{ marginTop: '24px' }} breakpoint="md">
              <Button
                uppercase={false}
                inline
                compact
                onClick={() => openChat()}
              >
                Start a chat
              </Button>
            </MobileOnly>
          </div>
        </BorderCard>

        <BorderCard>
          <BorderCardIcon>
            <SvgIconMail />
          </BorderCardIcon>
          <div>
            <h4>Send an email</h4>
            <ParagraphXs>
              A member of the team will get back to you within 24 hours.
            </ParagraphXs>
            <a href="mailto:support@riparide.com">support@riparide.com</a>
          </div>
        </BorderCard>

        <BorderCard>
          <BorderCardIcon>
            <SvgIconBookOpen />
          </BorderCardIcon>
          <div>
            <h4>PR & media enquiries</h4>
            <ParagraphXs>
              For interview requests, access to our Press Kit, and more.
            </ParagraphXs>
            <a href="mailto:marketing@riparide.com">marketing@riparide.com</a>
          </div>
        </BorderCard>
      </SectionRow>
    </>
  )
}

export default ConnectSection
